module.exports = __webpack_public_path__ + "img/posimage.a330ad2e.png";